import { axiosApiInstance } from './axios';

// -------------------------------------------------------------

const apiRoot = '';

const cigarPerformanceApi = {
  // GET
  get: async (params) => {
    try {
      const res = await axiosApiInstance.get(`${apiRoot}/cigarPerformance/byDates`, { params });

      return res;
    } catch (e: any) {
      return e.response;
    }
  },
};

export default cigarPerformanceApi;
